var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.valueFormat')
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "allow-create": ""
    },
    model: {
      value: (_vm.optionModel.valueFormat),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "valueFormat", $$v)
      },
      expression: "optionModel.valueFormat"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "yyyy-MM-dd",
      "value": "yyyy-MM-dd"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "yyyy-MM-dd HH:mm:ss",
      "value": "yyyy-MM-dd HH:mm:ss"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "yyyy-MM",
      "value": "yyyy-MM"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "yyyy",
      "value": "yyyy"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d35a4fd","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-date-range/date-range-valueFormat-editor.vue
// module id = null
// module chunks = 